import type { CostoFamilia } from "../../types";

export const FAMILIAS: { key: CostoFamilia; label: string; short: string }[] = [
  { key: "gcp", label: "BigQuery y GCP", short: "GCP" },
  { key: "manual", label: "Suscripciones y servidores", short: "Manuales" },
  { key: "ia", label: "Cuentas y consumo de IA", short: "IA" },
];

export const CATEGORIAS_MANUALES = ["VPS", "RunCloud", "Suscripciones", "Ads", "Cuentas IA", "APIs IA", "GCP", "Otros"];

const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const MESES_LARGO = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

export const mesCorto = (m: string) => MESES[Number(m.slice(5, 7)) - 1];
export const mesLargo = (m: string) => `${MESES_LARGO[Number(m.slice(5, 7)) - 1]} ${m.slice(0, 4)}`;

const clp = new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 });
export const fmtClp = (v: number | null | undefined) => (v == null ? "Sin datos" : clp.format(Math.round(v)));

export const mesPrevio = (m: string) => {
  const y = Number(m.slice(0, 4));
  const n = Number(m.slice(5, 7));
  return n === 1 ? `${y - 1}-12` : `${y}-${String(n - 1).padStart(2, "0")}`;
};

export type Moneda = "CLP" | "USD";

/** Texto de un monto con punto de miles; en USD admite coma y hasta 2 decimales. Solo da formato al texto. */
export function formatearMonto(raw: string, moneda: Moneda): string {
  const [entero, ...decimales] = raw.replace(/[^\d,]/g, "").split(",");
  const miles = entero.replace(/^0+(?=\d)/, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return moneda === "USD" && decimales.length ? `${miles},${decimales.join("").slice(0, 2)}` : miles;
}

export const montoANumero = (texto: string) => (texto === "" ? NaN : Number(texto.replace(/\./g, "").replace(",", ".")));

const usd = new Intl.NumberFormat("es-CL", { style: "currency", currency: "USD", currencyDisplay: "code", minimumFractionDigits: 2 });
export const fmtUsd = (v: number) => usd.format(v).replace(/\s/g, " ");

/** $1,2 M · $45 k · $900: para ejes y etiquetas angostas. */
export function fmtClpCorto(v: number): string {
  const a = Math.abs(v);
  if (a >= 1_000_000) return `$${(v / 1_000_000).toFixed(1).replace(".", ",")} M`;
  if (a >= 1_000) return `$${Math.round(v / 1_000)} k`;
  return `$${Math.round(v)}`;
}

export const mesAnterior = (m: string, meses: string[]) => {
  const i = meses.indexOf(m);
  return i > 0 ? meses[i - 1] : null;
};
